import { render, staticRenderFns } from "./MainPageContactForm.vue?vue&type=template&id=5d2ac270&scoped=true&"
import script from "./MainPageContactForm.vue?vue&type=script&lang=js&"
export * from "./MainPageContactForm.vue?vue&type=script&lang=js&"
import style0 from "./MainPageContactForm.vue?vue&type=style&index=0&id=5d2ac270&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d2ac270",
  null
  
)

export default component.exports